export const isEmptyChild = (children: React.ReactNode): boolean =>
  Array.isArray(children) ? children.length === 0 : !children;
